// Convert desktop nav dropdowns from click to hover
document.addEventListener('DOMContentLoaded', () => {
  const isDesktop = () => window.innerWidth >= 1025;

  document.querySelectorAll('.header__inline-menu details').forEach(details => {
    details.addEventListener('mouseenter', () => {
      if (!isDesktop()) return;
      details.open = true;
    });

    details.addEventListener('mouseleave', () => {
      if (!isDesktop()) return;
      details.open = false;
    });
  });
});
